export interface StaticDataLayerObject {
	site?: string;
	market?: string;
	language?: string;
	pageName?: string;
	pageUrl?: string;
	loggedID?: string;
	victoria_user?: string;
	tier_level?: string;
	miles_balance?: string;
	for_code?: string;
	pnr_nr?: string;
	flight_type?: string;
	flight_originairportcity?: string;
	flight_destinationairportcity?: string;
	flight_origincityname?: string;
	flight_destinationcityname?: string;
	flight_segments?: string;
	flight_route?: string;
	flight_departuredate?: string;
	flight_returndate?: string;
	flight_haul?: string;
	flight_brand?: string;
	flight_rbd?: string;
	flight_cabin?: string;
	flight_number?: string;
	flight_stopover?: string;
	flight_timetothink?: string;
	flight_bookingdate?: string;
	travel_duration?: string;
	passengers_nr?: string;
	adults_nr?: string;
	infants_nr?: string;
	children_nr?: string;
	youngadult_nr?: string;
	office_id?: string;
	payment_type?: string;
	miles_used?: string;
	miles_used_p1?: string;
	miles_used_p2?: string;
	primary_email?: string;
	customer_email?: string;
	award_shopper_availability?: string;
	star_alliance_availability?: string;
	x_tap_source?: string;
	x_tap_username?: string;
	x_tap_correlationid?: string;
}

export interface EventDataLayerActionFieldObject {
	list?: string;
	step?: string;
	id?: string;
	revenue?: string;
	tax?: string;
	coupon?: string;
}

export interface EventDataLayerProductObject {
	id?: string;
	name?: string;
	category?: string;
	variant?: string;
	brand?: string;
	quantity?: string;
	price?: string;
	coupon?: string;
	dimension1?: string;
	dimension2?: EventPaymentCashEnumDimension2;
}

export enum EventPaymentCashEnumDimension2 {
	CreditCard = 'CC',
	BankTransfer = 'BT',
	DebitCard = 'DC',
	MBWAY = 'MBW',
	Multibanco = 'MB',
	Alipay = 'AP',
	Paypal = 'PP',
	KlarnaPayNow = 'SF',
	KlarnaPayLater = 'KL',
	POLi = 'PI',
	IDeal = 'IL',
	Miles = 'miles',
	Multicaixa = 'MX',
	MulticaixaExpress = 'ME',
	Pickup = 'PU',
	CaixaLoterias = 'SC',
	BankTransferBr = 'SB',
}

export interface EventDataLayerObject {
	actionField?: EventDataLayerActionFieldObject;
	products?: Array<EventDataLayerProductObject>;
}

// OLD

export interface DimensionsFieldObject {
	dimension1?: string;
	dimension2?: string;
	dimension3?: string;
	dimension4?: string;
	dimension5?: string;
	dimension6?: string;
	dimension7?: string;
	dimension8?: string;
	dimension9?: string;
	dimension10?: string;
	dimension11?: string;
	dimension12?: string;
	dimension13?: string;
	dimension14?: string;
	dimension15?: string;
	dimension16?: string;
	dimension17?: string;
	dimension18?: string;
	dimension19?: string;
	dimension20?: string;
	dimension21?: string;
	dimension22?: string;
	dimension23?: string;
	dimension24?: string;
	dimension25?: string;
	dimension26?: string;
	dimension27?: string;
	dimension28?: string;
	dimension29?: string;
	dimension30?: string;
	dimension31?: string;
	dimension32?: string;
	dimension33?: string;
	dimension34?: string;
	dimension35?: string;
	dimension36?: string;
	dimension37?: string;
	dimension38?: string;
	dimension39?: string;
	dimension40?: string;
	nonInteractive?: boolean;
}

export interface ProductFieldObject extends DimensionsFieldObject {
	id?: string;
	name?: string;
	brand?: string;
	category?: string;
	variant?: string;
	price?: number;
	quantity?: number;
	coupon?: string;
	position?: number;
}

export interface ImpressionFieldObject {
	id: string;
	name?: string;
	list?: string;
	brand?: string;
	category?: string;
	variant?: string;
	position?: number;
	price?: number;
}

export interface ActionFieldObject {
	id?: string;
	affiliation?: string;
	revenue?: number;
	tax?: number;
	shipping?: number;
	coupon?: string;
	list?: string;
	step?: number;
	option?: string;
}
